import React from 'react';
import { Container, ButtonForm } from './styles';
import FormDefault from '~/components/FormDefault';
import { useAlteracaoIbsCbsLote } from './hooks/useAlteracaoIbsCbsLote';
import { Tooltip } from '@material-ui/core';
import { InputIbsCbs } from '~/components/NovosInputs/InputIbsCbs';
import { Spinner } from 'react-bootstrap';
import { Form } from './components/Form';
import { Table } from './components/Table';
import { BsFillLightningChargeFill } from 'react-icons/bs';

export const AlteracaoIbsCbsLoteContent: React.FC = () => {
  const {
    onTransfer,
    resetFormData,
    formAlteracaoIbsCbs: {
      register,
      control,
      formState: { errors },
      setValue,
    },
    loadingSubmit,
  } = useAlteracaoIbsCbsLote();

  const CusttomButtons = () => {
    return (
      <>
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            paddingLeft: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              flex: 1,
              minWidth: 0,
            }}
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              Novo IBS/CBS:
            </span>

            <div
              style={{
                flex: 1,
                marginBottom: '26px',
                minWidth: '30rem',
              }}
            >
              <InputIbsCbs
                style={{ width: '100%', flex: 1 }}
                register={register}
                control={control}
                hideNoneOption
                isError={!!errors.cod_ibs_cbs}
                name="cod_ibs_cbs"
                changeSelected={(value) => {
                  setValue('cod_ibs_cbs', value);
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '2px',
              alignItems: 'center',
            }}
          >
            <Tooltip title="Transferir">
              <ButtonForm
                style={{
                  backgroundColor: '#9900ff',
                  display: 'flex',
                  alignItems: 'center',
                  height: '38px',
                }}
                onClick={async () => {
                  await onTransfer();
                }}
                disabled={false}
              >
                {loadingSubmit && (
                  <Spinner animation="border" variant="light" size="sm" />
                )}
                <BsFillLightningChargeFill size={20} />
                Transferir
              </ButtonForm>
            </Tooltip>
          </div>
        </div>
      </>
    );
  };

  return (
    <Container>
      <FormDefault
        codTela={318}
        title="Alteração de IBS/CBS em Lote"
        onSave={() => Promise.resolve()}
        isUpdate={false}
        onCancel={() => []}
        onNew={() => []}
        onDelete={() => []}
        onClearFields={resetFormData}
        onReturnSearch={() => []}
        isSave
        isCancel={false}
        showIconSave={false}
        isBackSearch={false}
        customButtons={<CusttomButtons />}
      >
        <Form />
        <Table />
      </FormDefault>
    </Container>
  );
};
